import { statementsService } from "./statementsService";
import { IStatementListResponse } from "./types";

export const getStatements = async (): Promise<IStatementListResponse> => {
  const { data } = await statementsService.get("/internal-account-statements");

  return data;
};
